import { render, staticRenderFns } from "./CategoriesModules.vue?vue&type=template&id=9124b93e&scoped=true&"
import script from "./CategoriesModules.vue?vue&type=script&lang=js&"
export * from "./CategoriesModules.vue?vue&type=script&lang=js&"
import style0 from "./CategoriesModules.vue?vue&type=style&index=0&id=9124b93e&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9124b93e",
  null
  
)

component.options.__file = "CategoriesModules.vue"
export default component.exports